export default {"src":"/_next/static/media/arrow1.b285fd83.svg","height":5,"width":5,"blurWidth":0,"blurHeight":0};